import clsx from 'clsx';
import { usePathname } from 'hooks/usePathname/usePathname';
import { Link } from 'react-router-dom';
import { getPathname } from 'utils/common/common';
import styles from '../Navigation.module.css';

type TProps = {
  href: string;
  label: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
};

export const NavItemLink = ({
  href,
  label,
  onClick,
  className,
  disabled,
}: TProps) => {
  const pathname = usePathname() || '/';

  return (
    <div
      className={clsx(
        styles.navItem,
        { [styles.disabled]: disabled },
        className,
      )}
    >
      <Link
        to={href}
        onClick={onClick}
        className={clsx(styles.navItemLink, {
          [styles.navItemLinkActive]: pathname === getPathname(href),
        })}
        data-testid={`${href.substring(1)}-link`}
      >
        <span>{label}</span>
      </Link>
    </div>
  );
};
